import { render } from "./Subscriptions.vue?vue&type=template&id=124c91fa"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"
script.render = render

export default script